import { render } from "./GalleryImage.vue?vue&type=template&id=4e67a708&scoped=true"
import script from "./GalleryImage.vue?vue&type=script&lang=js"
export * from "./GalleryImage.vue?vue&type=script&lang=js"

import "./GalleryImage.vue?vue&type=style&index=0&id=4e67a708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e67a708"]])

export default __exports__